import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Checkbox } from "@/components/ui/checkbox";

interface Props {
  acceptTerms: boolean;
  acceptPolicy: boolean;
  onTermsChange: (v: boolean) => void;
  onPolicyChange: (v: boolean) => void;
}

const LegalConsentCheckboxes = ({ acceptTerms, acceptPolicy, onTermsChange, onPolicyChange }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="space-y-3">
      <div className="flex items-start gap-2">
        <Checkbox id="accept-terms" checked={acceptTerms} onCheckedChange={(v) => onTermsChange(v === true)} className="rounded-full h-5 w-5 min-h-5 max-h-5 shrink-0 mt-0.5" />
        <label htmlFor="accept-terms" className="text-sm leading-snug">
          {t("legalConsent.termsPrefix")}{" "}
          <Link to="/terms-of-service" target="_blank" className="text-primary underline">{t("legalConsent.termsLink")}</Link>
        </label>
      </div>
      <div className="flex items-start gap-2">
        <Checkbox id="accept-policy" checked={acceptPolicy} onCheckedChange={(v) => onPolicyChange(v === true)} className="rounded-full h-5 w-5 min-h-5 max-h-5 shrink-0 mt-0.5" />
        <label htmlFor="accept-policy" className="text-sm leading-snug">
          {t("legalConsent.policyPrefix")}{" "}
          <Link to="/data-processing-policy" target="_blank" className="text-primary underline">{t("legalConsent.policyLink")}</Link>
        </label>
      </div>
    </div>
  );
};

export default LegalConsentCheckboxes;
